import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefundAmountComponent } from 'src/app/Product/refund-amount/refund-amount.component';
import { PaymentService } from 'src/app/_services/payment.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_alert';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RefundService } from 'src/app/_services/refund.service';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-raise-refund-request',
  templateUrl: './raise-refund-request.component.html',
  styleUrls: ['./raise-refund-request.component.css']
})
export class RaiseRefundRequestComponent implements OnInit {
  serviceCharge: any
  refundAmount: any;
  reason: any = [];
  submitted: boolean = true;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  dataFromService: any;
  refundDataFromService: any;
  private subscription: Subscription;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<RaiseRefundRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public paymentService: PaymentService,
    public alertService: AlertService,
    public commonService: CommonService,
    public refundService: RefundService,
    public route: ActivatedRoute) {
    this.subscription = this.paymentService.data$.subscribe(data => {
      this.dataFromService = data;
      console.log(this.dataFromService)
    });
    this.subscription = this.refundService.refundAmt$.subscribe(refundAmt => {
      this.refundDataFromService = refundAmt;
      console.log(this.refundDataFromService)
    });
  }

  ngOnInit(): void {
    //refund reason
    this.refundService.refundReason().subscribe((response) => {
      console.log(response);
      this.reason = response;
    })
    console.log(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();

  }
  refundForm = new FormGroup(
    {
      AFSTransactionId: new FormControl(this.data.AFSTransactionId, [Validators.required]),
      RefundAmount: new FormControl(this.data.RefundAmount, [Validators.required]),
      ReasonCode: new FormControl(this.data.ReasonCode, [Validators.required]),
      Comment: new FormControl(this.data.Comment),
      SendRequestedNotification: new FormControl(this.data.SendRequestedNotification),
      SendProcessedNotification: new FormControl(this.data.SendProcessedNotification)
    }
  )

  get forms() {
    return this.refundForm.controls;
  }

  refundSubmit() {
    this.submitted = true;
    if (this.refundForm.valid) {
      console.log(this.data);
      const dialogRef = this.dialog.open(RefundAmountComponent, {
        width: '500px',
        disableClose: true,
        data: { refundData: this.data }
      });
      this.dialogRef.close();
    }
    else {
      console.log("Error!!Please enter valid data.");
      this.alertService.error("Error!!Please enter valid data.", this.options);
    }
  }
}

